import Cookies from 'js-cookie';

type CookieValue = string | number | boolean | null | undefined;

const DEFAULT_EXPIRE_TIME_MS = new Date().setTime(new Date().getTime() + 15 * 60 * 1000);

export function setCookie(name: string, value: CookieValue, expireTime?: number) {
  const finalName = name?.trim();

  if (!finalName || value == null || (typeof value === 'string' && value.trim() === '')) {
    return;
  }

  const finalExpireTimeMs = expireTime ?? DEFAULT_EXPIRE_TIME_MS;

  Cookies.set(finalName, String(value), { expires: finalExpireTimeMs });
}

export function removeCookie(name: string) {
  const finalName = name.trim();
  if (!finalName) {
    return;
  }

  Cookies.remove(finalName);
}

export function removeCookies(names: string[]) {
  names.forEach(removeCookie);
}
